module.exports={
    title:'合约量化机器人，安全便捷高效让交易更安心。',
    ul_li1:'联系客服',
    ul_li2:'帮助中心',
    ul_li2_phone:'帮助中心',
    ul_li3:'OKX注册地址',
    ul_li4:'服务条款',
    ul_li4_phone:'服务条款',
    download_app: '下载App',
    send: '发送',
    feedback:'意见反馈',
    select_question_type:'选择问题类型',
    problem_description:'问题描述',
    please_enter_content:'请输入内容',
    add_photo:'添加照片',
    submit:'提交',
    scan_qr_code:'扫描二维码下载',
    ios_coming_soon:'IOS即将上线',
    complain:'投诉',
    suggestion:'建议',
    fault:'故障',
    other:'其他',
    content_yet:'暂无内容',
    fee_exemption:'免燃料费政策即将到期',
    live_broadcast:'UPLUS直播'
}
